module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOC42NSAxOC42NSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM2ZDdkODE7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT50aXAtY2xvc2U8L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjE2Ljc5IDAgOS4zMyA3LjQ2IDEuODcgMCAwIDEuODcgNy40NiA5LjMzIDAgMTYuNzkgMS44NyAxOC42NiA5LjMzIDExLjE5IDE2Ljc5IDE4LjY2IDE4LjY2IDE2Ljc5IDExLjE5IDkuMzMgMTguNjYgMS44NyAxNi43OSAwIi8+PC9nPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon--close-dark.svg
// module id = 1289
// module chunks = 168707334958949